import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-error-notification',
  templateUrl: './error-notification.component.html',
  imports: [NgClass],
})
export class ErrorNotificationComponent {
  @Input() public id: string = '';
  @Input() public title: string = '';
  @Input() public classes: string | string[] | Set<string> | { [klass: string]: any } = '';
}
